import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./system-element-query-key-factory";

export const getSystemElementCategorizedEntity = ({ elementId }: { elementId: string }) => {
  return Brm.systemElementApi.getSystemElementCategorizedentity(elementId);
};

interface IUseSystemCategorizedEntity {
  elementId: string;
  options?: QueryOption<typeof getSystemElementCategorizedEntity>;
}

/**
 * React-query hook for getting categorizedEntity from any system element
 *
 * @param {string} elementId - uuid of the project
 * @returns react-query for getSystemElements
 */
export const useSystemElementCategorizedEntity = ({ elementId, options }: IUseSystemCategorizedEntity) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.systemElementKeys.categorizedEntity(elementId),
    queryFn: () => getSystemElementCategorizedEntity({ elementId }),
  });
};
